// src/features/landing/presentation/pages/ContactPage.jsx
import React from "react";
import { PartnershipIntroSection } from "../components/PartnershipIntroSection";
import { CompanyContactSection } from "../components/CompanyContactSection";
import { Footer } from "../components/Footer";

import "../styles/landing.css";

export function ContactPage() {
    return (
        <>
            <div style={{ paddingTop: '40px' }}>
                <PartnershipIntroSection />
                <CompanyContactSection />
            </div>
            <Footer />
        </>
    );
}
